import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import "../../style/AllCarsAdmin.css";
import { Spin } from "antd";
import CarRequestModal from "../CarRequestModal";

function CarAdRequests() {
  const { authToken, logout } = useAuth();
  const [username, setUsername] = useState("");
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAd, setSelectedAd] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!authToken) {
        navigate("/");
        return;
      }
      try {
        const userRes = await api.get("usuario/getbyToken");
        setUsername(userRes.data.nombre);
        const res = await api.get("pendingcarads");
        const pendings = res.data.filter((a) => a.status === "pending");
        setAds(pendings);
      } catch (err) {
        console.error("Error fetching ads:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [authToken, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const openModal = (ad) => setSelectedAd(ad);
  const closeModal = () => setSelectedAd(null);

  const handleAction = async (id, action) => {
    try {
      await api.patch(`pendingcarads/${action}/${id}`, {});
      setAds(ads.filter((ad) => ad._id !== id));
    } catch (err) {
      console.error("Error updating ad:", err);
    }
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Solicitudes de anuncios</p>
            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : (
              <>
                <div className="overview-container" style={{ overflow: "auto", maxHeight: "700px", alignItems: "flex" }}>
                  {ads.map((ad) => (
                    <div className="overview-item" key={ad._id} onClick={() => openModal(ad)}>
                      <p style={{ width: "20%", marginLeft: "0.5rem" }}>{ad.usuario?.nombre}</p>
                      <p style={{ width: "30%", marginLeft: "0rem" }}>{ad.usuario?.correo}</p>
                      <p style={{ width: "20%", marginLeft: "0.5rem" }}>{ad.marca} {ad.modelo} {ad.anio}</p>
                      <div style={{ width: "40%", display: "flex", gap: "0.5rem", justifyContent: "flex-end", marginRight: "0.5rem" }}>
                        <button className="red-button" onClick={(e) => { e.stopPropagation(); handleAction(ad._id, "approve"); }}>Aprobar</button>
                        <button className="red-button" onClick={(e) => { e.stopPropagation(); handleAction(ad._id, "reject"); }}>Rechazar</button>
                      </div>
                    </div>
                  ))}
                  {ads.length === 0 && (
                    <p className="no-notifications">No hay solicitudes pendientes</p>
                  )}
                </div>
              </>
            )}
            <CarRequestModal ad={selectedAd} onClose={closeModal} />
            </div>
          </div>
        </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default CarAdRequests;
